import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import imglogo from '../../../assets/img/logo_t4i.png'
import bgAuthenticate from '../../../assets/img/bg-authenticate.png'
import { useAuthentication } from '../../../customHooks/useAuthentication'
import { clearStaffGoogleCompletion, readStaffGoogleCompletion, registerStaffGoogle, staffGoogleMessage } from '../../../services/staffGoogle'
import '../login.css'

function GoogleFinishRegistration() {
  const { formatMessage: trans } = useIntl()
  const history = useHistory()
  const { saveItemInLocalStorage } = useAuthentication()
  const pending = useRef(readStaffGoogleCompletion())
  const record = pending.current
  const missing = record?.missing || []
  const needsName = missing.indexOf('name') !== -1 || !String(record?.profile?.name || '').trim()
  const [name, setName] = useState(String(record?.profile?.name || ''))
  const [companyName, setCompanyName] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const lock = useRef(false)

  const submit = (event) => {
    event.preventDefault()
    if (lock.current || !record) return
    if (!companyName.trim() || (needsName && !name.trim())) {
      setError(trans({ id: 'staff_google_finish_required', defaultMessage: 'Business name and contact name are required.' }))
      return
    }
    lock.current = true
    setBusy(true)
    setError('')
    registerStaffGoogle({
      completion_code: record.completion_code,
      name: name.trim(),
      companyName: companyName.trim(),
    }).then((res) => {
      const data = res?.data || {}
      if (res?.status === 200 && data.status && data.outcome === 'registered') {
        clearStaffGoogleCompletion()
        saveItemInLocalStorage('item_validation_info', {
          email: record.profile?.email || '',
          phoneNumber: '',
        })
        history.push('/validation_selection')
        return
      }
      lock.current = false
      setBusy(false)
      setError(staffGoogleMessage(trans, data))
    })
  }

  if (!record) {
    return (
      <div className="login">
        <div className="hero-split">
          <img alt="" className="hero-image" src={bgAuthenticate} />
        </div>
        <div className="form-split">
          <div className="form-container">
            <p className="message_error" role="alert">
              {trans({ id: 'staff_google_code_expired', defaultMessage: 'This Google sign-in expired. Start again.' })}
            </p>
            <button type="button" className="secondary-button" onClick={() => history.push('/sign_up')}>
              {trans({ id: 'staff_google_start_again', defaultMessage: 'Start again' })}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="login">
      <div className="hero-split">
        <img alt="" className="hero-image" src={bgAuthenticate} />
      </div>
      <div className="form-split">
        <div className="form-container__signup">
          <div className="form-container_top form-container_top--signup">
            <img alt="Tech4Inventory" className="logo" src={imglogo} />
            <h1 className="title-app">{trans({ id: 'staff_google_finish_title', defaultMessage: 'Finish your account' })}</h1>
            <span className="subtitle-app">{trans({ id: 'staff_google_finish_subtitle', defaultMessage: 'Google confirmed your email. Add the business details for this workspace.' })}</span>
          </div>
          <form className="form" onSubmit={submit} noValidate>
            <div className="theinputs">
              <div className="input-group">
                <label className="label" htmlFor="staff-google-email">
                  {trans({ id: 'staff_google_finish_email', defaultMessage: 'Email' })}
                </label>
                <input id="staff-google-email" className="input" value={record.profile?.email || ''} readOnly />
              </div>
              {needsName ? (
                <div className="input-group">
                  <label className="label" htmlFor="staff-google-name">
                    {trans({ id: 'staff_google_contact_name', defaultMessage: 'Contact name' })}
                  </label>
                  <input
                    id="staff-google-name"
                    className={classNames('input', { 'is-invalid': !name.trim() && error })}
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    autoComplete="name"
                  />
                </div>
              ) : null}
              <div className="input-group">
                <label className="label" htmlFor="staff-google-company">
                  {trans({ id: 'staff_google_business_name', defaultMessage: 'Business name' })}
                </label>
                <input
                  id="staff-google-company"
                  className="input"
                  value={companyName}
                  onChange={(event) => setCompanyName(event.target.value)}
                  autoComplete="organization"
                />
              </div>
              {error ? (
                <p className="message_error" role="alert">
                  {error}
                </p>
              ) : null}
              <button className="primary-button" type="submit" disabled={busy} aria-busy={busy}>
                {trans({ id: 'staff_google_finish_submit', defaultMessage: 'Create account' })}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default GoogleFinishRegistration
